import { render, staticRenderFns } from "./CurrentDate.vue?vue&type=template&id=26c2ea20&scoped=true"
import script from "./CurrentDate.vue?vue&type=script&lang=js"
export * from "./CurrentDate.vue?vue&type=script&lang=js"
import style0 from "./CurrentDate.vue?vue&type=style&index=0&id=26c2ea20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c2ea20",
  null
  
)

export default component.exports